import { Link, Text } from "@fluentui/react";
import { RootState } from "app/store";
import { AppLinkTo } from "global/Application";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

interface IProps {
    name: string;
    id: string;
    type: string;
    disabled?: boolean;
}

const typeToLink: Record<string, "plan" | "benefit" | "stopLoss" | "accountsReceivable" | "feesAndPremium" | "checkListWithPlan"> = {
    'planRef': 'plan',
    'benefitRef': 'benefit',
    'stopLossRef': 'stopLoss',
    'accountsReceivableRef': 'accountsReceivable',
    'feesAndPremiumRef': 'feesAndPremium',
    'checklistRef': 'checkListWithPlan',
}

const RefLink = (props: IProps) => {
    const history = useHistory();

    const state = useSelector((state: RootState) => state);

    // return <>{props.name}</>;

    if (props.disabled)
        return (
            <Text>
                {props.name}
            </Text>
        );

    return (
        <Link
            onClick={() => history.push(AppLinkTo(state, { id: props.id, type: typeToLink[props.type] }))}
        >
            {props.name}
        </Link>
    );
}

export default RefLink;